<template>
	<a class="subscribe-button" :href="subscriptionUrl">
		<span class="subscribe-button-container">

			<span class="months">
				<span class="amount">
					{{ months }}
				</span>

				<span class="label">
					{{ months > 1 ? "meses" : "mês" }}
				</span>
			</span>

			<span class="price">
				<span class="full-price">
					<span class="amount">
						R$ {{ (price).pad(0,2) }}
					</span>
				</span>

				<span class="discount-price" v-if="discount">
					<span class="amount">
						R$ {{ (price - discount).pad(0,2) }}
					</span>
				</span>
			</span>
		</span>
	</a>
</template>

<script>
	export default {
		name: 'SubscriptionButton',
		props: {
			months: {
				type: Number,
				required: true
			},
			price: {
				type: Number,
				required: true
			},
			discount: {
				type: Number,
				required: true
			},
		},
		computed: {
			subscriptionUrl() {
				return this.$oldApi.getUrl({url: 'Donation.Donate', params: {'months': this.months}});
			}
		}
	}
</script>

<style lang="scss" scoped>
	.subscribe-button {
		display: block;
		height: 95px;

		background: rgba($light, .2);

		transition: .3s all;
		border-radius: 25px;

		&:hover {
			background: rgba($light, .3);
		}


		.subscribe-button-container {
			display: flex;
			align-items: center;

			height: 100%;
		}

		.months {
			min-width: 50%;
			text-align: center;

			line-height: $font-size-xl;
			padding: 0 $font-size-lg;

			.amount {
				font-weight: $font-weight-bold;
				font-size: $font-size-xxl;
				display: block;
			}
			.label {
				font-size: $font-size-md;
				display: block;
			}
		}

		.price {
			min-width: 50%;
			display: flex;
			flex-direction: column;

			padding: 0 $font-size-lg 0 0;
			text-align: center;

			.full-price {
				text-decoration: line-through;
				line-height: $font-size-xxs;
				white-space: nowrap;

				&:last-child {
					font-size: $font-size-xl;
					line-height: $font-size-xxl;
					text-decoration: none;
				}
			}

			.discount-price {
				font-size: $font-size-xl;
				white-space: nowrap;
			}
		}
	}
</style>
